// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconReturn: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="currentColor">
            <path
                d="M13.5937504,6.56235329 C13.5937504,10.1775875 10.6494145,13.1219234 7.03418031,13.1219234 C5.60332105,13.1219234 4.24599677,12.6654785 3.10253978,11.8076651 C2.6888676,11.4974113 2.60537133,10.9094229 2.91577175,10.4948723 C3.22602555,10.0812005 3.81284192,9.99858312 4.22856465,10.3081047 C5.04418954,10.9207024 6.01567402,11.2438469 7.03754872,11.2438469 C9.6181637,11.2439936 11.71875,9.14340816 11.71875,6.56235329 C11.71875,3.98129843 9.61845696,1.88071302 7.03710973,1.88071302 C5.93964905,1.88071302 4.89580125,2.27592758 4.06933621,2.95415006 L5.39121106,4.27661053 C5.88955075,4.77524392 5.53637713,5.62719665 4.83164057,5.62719665 L0.56162104,5.62719665 C0.251367241,5.62778316 0,5.37582985 0,5.0652828 L0,0.792041043 C0,0.0877439172 0.851660371,-0.264990708 1.34970725,0.233349422 L2.74423867,1.62875972 C3.92285183,0.606591323 5.43457076,0.00307551928 7.03418031,0.00307551928 C10.6494145,0.00307551928 13.5937504,2.9471191 13.5937504,6.56235329 Z"
                transform="translate(.469 .813)"
            />
        </svg>
    );
};

export default React.memo(IconReturn);
